import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.oms')
  .filter('omsPackageWeightTotal', omsPackageWeightTotal);

function omsPackageWeightTotal(splitService, $filter) {
  return function bringozOmsPackageWeightTotal(packageRef, enableUnitDisplay) {

    if (!packageRef) {
      return '--';
    }

    var itemsWeightSum;
    var hasAnyWeight = false;

    itemsWeightSum = _.reduce(packageRef,  (sum,p) =>{
      if (!_.isUndefined(p?.weight)) {
        hasAnyWeight = true;
      }
      return   sum + _.get(p, 'weight', 0) * _.get(p, 'count', 0);
    }, 0);

    return hasAnyWeight? $filter('bringozWeight')(itemsWeightSum, enableUnitDisplay):'--';
  };
}
